// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1_WiS","file":"styles_file__2lJfc"};